import { render, staticRenderFns } from "./about-us.vue?vue&type=template&id=438cd660&scoped=true&"
import script from "./about-us.vue?vue&type=script&lang=js&"
export * from "./about-us.vue?vue&type=script&lang=js&"
import style0 from "./about-us.vue?vue&type=style&index=0&id=438cd660&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438cd660",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IntSlides: require('/var/www/ep-web/components/IntSlides.vue').default,ContactForm: require('/var/www/ep-web/components/ContactForm.vue').default})
